export const THUMBNAIL = "THUMBNAIL";
export const FULL = "FULL";